var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-banner dp-f", attrs: { id: "app_banner" } },
    [
      _c("div", { staticClass: "home-banner-eagle" }, [
        _c("div", { staticClass: "eagle-pic" }, [
          _c("img", { attrs: { src: _vm.currentBanner } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "eagle-buy dp-f" }, [
          _c(
            "a",
            { staticClass: "but-now", attrs: { href: "javascript:;" } },
            [
              _c(
                "e-button",
                {
                  staticClass: "buy-now-button",
                  attrs: { type: "primary", round: "" },
                  on: { click: _vm.freeTrialClick }
                },
                [
                  _vm._v(
                    _vm._s(_vm.getConstants("BOXCRYPTOR_LANDING_COMMON_FREE"))
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "buy-detai", attrs: { href: "#app_sale" } },
            [
              _c("e-button", { attrs: { round: "" } }, [
                _vm._v(
                  _vm._s(_vm.getConstants("BOXCRYPTOR_LANDING_BANNER_BUYNOW"))
                )
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "home-banner-display" }, [
        _c("img", { attrs: { src: _vm.appBanner.bannerDisplay, alt: "" } })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }